<template>
    <cadastro-simples-list
        endpoint="periodo-referencia"
        rota-base="/admin/periodo-referencia"
        titulo="PERÍODOS (REFERÊNCIA)"
        titulo-singular="Período"
        :colunas-extras='[
            { campo: "hora_inicio", label: "Hora Início", tipo: "string" },
            { campo: "hora_fim", label: "Hora Fim", tipo: "string" }
        ]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
